import { logError } from './errorHandlers';
import isServerSideRendering from './isServerSideRendering';
import safeParse from './safeParse';

export function loadItemFromLocalStorage<T>(name: string): T | undefined {
  if (isServerSideRendering) return undefined;

  const serializedState = window.localStorage.getItem(name);

  return serializedState ? safeParse(serializedState) ?? undefined : undefined;
}

export function saveItemToLocalStorage(name: string, state: any): boolean {
  try {
    window.localStorage.setItem(name, JSON.stringify(state));

    return true;
  } catch (err) {
    logError(err, { location: 'Save item to localStorage' });

    return false;
  }
}
